module.exports = __webpack_public_path__ + "static/media/icon_video_zoomout_bk.df020510.svg";